import { VaroCategories } from 'shared/analytics/types/categories';
import { createBaseEventsMap } from 'shared/analytics/utils/createBaseEventsMap';

const EVENT_KEYS = {
  TRANSFER_MONEY_GRAPHQL_OPERATION: 'GraphQL Operation',
  TRANSFER_MONEY_CLIENT_ERROR: 'Client Error',
  TRANSFER_MONEY_SUCCESSFUL: 'Transfer Money Successful',
  TRANSFER_MONEY_FLOW_ERROR_ENCOUNTERED:
    'Transfer Money Flow Error Encountered',
};

export type VaroTransferMoneyEvents =
  (typeof EVENT_KEYS)[keyof typeof EVENT_KEYS];

const events = createBaseEventsMap<VaroTransferMoneyEvents>(
  EVENT_KEYS,
  VaroCategories.TRANSFER_MONEY,
);

export const {
  TRANSFER_MONEY_GRAPHQL_OPERATION,
  TRANSFER_MONEY_CLIENT_ERROR,
  TRANSFER_MONEY_SUCCESSFUL,
  TRANSFER_MONEY_FLOW_ERROR_ENCOUNTERED,
} = events;
